import { useEffect, useState } from "react";

export const coreState = { px: 0, py: 0, glowTarget: 0, pulse: 0, lum: 0, reduced: false, lit: false };

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

let gl;
export const hasWebGL = () => {
  if (gl !== undefined) return gl;
  try {
    const c = document.createElement("canvas");
    gl = !!(window.WebGLRenderingContext && (c.getContext("webgl2") || c.getContext("webgl")));
  } catch {
    gl = false;
  }
  return gl;
};

export const useIsMobile = () => {
  const q = "(max-width: 767px)";
  const [m, setM] = useState(() => window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const on = () => setM(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return m;
};

export const EASE = [0.22, 1, 0.36, 1];
